.cell {
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  min-width: 0;
}

.right {
  align-items: flex-end;
}

.left {
  align-items: flex-start;
}

/* Axiforma, not Bebas — Bebas is reserved for display headings and tags */
.value {
  font-family: var(--font-sans);
  font-size: var(--text-base);
  font-weight: var(--weight-semi);
  color: var(--text-primary);
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* Magnitude bar. Full width of the cell so bars align across rows.
   Height is overridable per table via --metric-bar-height. */
.track {
  display: block;
  width: 100%;
  height: var(--metric-bar-height, 3px);
  border-radius: var(--radius-pill);
  background: var(--bg-active);
  overflow: hidden;
}

.fill {
  display: block;
  height: 100%;
  border-radius: var(--radius-pill);
}

.revenue {
  background: var(--accent-secondary);
}

.share {
  background: var(--data-1);
}

.acquired {
  background: var(--metric-acquired);
}

.retained {
  background: var(--metric-retained);
}

.neutral {
  background: var(--text-muted);
}

/* Losses (churns, net subscriber loss) — the bar shows size, crimson says loss */
.decline {
  background: var(--metric-loss);
}

.sub {
  font-size: var(--text-xs);
  font-weight: var(--weight-semi);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
  line-height: 1;
  white-space: nowrap;
}

.good {
  color: var(--color-success);
}

.bad {
  color: var(--color-danger);
}

.muted {
  color: var(--text-muted);
}
